import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/base/Seo";
import PageHeader from "@/components/feature/PageHeader";
import History from "./components/History";
import Mission from "./components/Mission";
import Team from "./components/Team";
import Values from "./components/Values";
import CallToAction from "@/pages/home/components/CallToAction";

const associationHeroImage =
  "https://readdy.ai/api/search-image?query=Warm%20editorial%20wide%20photograph%20of%20diverse%20volunteers%20in%20red%20vests%20gathered%20together%20smiling%20in%20a%20bright%20community%20hall%20preparing%20food%20packages%2C%20soft%20natural%20window%20light%2C%20hopeful%20generous%20solidarity%20atmosphere%2C%20premium%20humanitarian%20campaign%20photography%2C%20clean%20composition%2C%20high%20detail&width=1600&height=500&seq=humanity59-association-hero&orientation=landscape";

export default function Association() {
  return (
    <div className="min-h-screen flex flex-col">
      <Seo
        title="L'association | Humanity59 — mission, valeurs et équipe"
        description="Découvrez Humanity59, association humanitaire de Lille : notre mission, nos valeurs, notre équipe et notre histoire au service de la solidarité internationale."
        keywords="association humanitaire, mission, valeurs, équipe, solidarité"
        path="/association"
      />
      <Header />
      <main className="flex-1">
        <PageHeader
          title="L'association"
          subtitle="Découvrez qui nous sommes, ce qui nous anime et les personnes qui font vivre Humanity59 au quotidien."
          image={associationHeroImage}
        />
        <History />
        <Mission />
        <Team />
        <Values />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
}